/* eslint-disable react/prop-types */
import { Button, Paragraph, Typography } from '@tmov/design-system';
import React, { useState } from 'react';

import { capitalizar } from '../../../../helpers/capitalizar';
import { formatarTonelada } from '../../../../helpers/formatador';
import ModalMaisDetalhes from './ModalMaisDetalhes';
import { Container, ContainerDetalhes, Header, Item, Row } from './styles';

export default function CotacaoDetalhes({ cotacao }) {
  const [modalVisible, setModalVisible] = useState();

  const {
    cidade_origem_nome,
    cidade_origem_estado,
    cidade_destino_nome,
    cidade_destino_estado,
    volume,
    cadencia,
    produto_descricao,
  } = cotacao;

  const handleMaisDetalhes = async () => {
    setModalVisible(true);
  };

  return (
    <ContainerDetalhes>
      <Header>
        <Typography variant="h4">Detalhes da cotação</Typography>
        <Button variant="text" onClick={handleMaisDetalhes}>
          Ver mais
        </Button>
      </Header>
      <Container>
        <Row>
          <Item>
            <Paragraph>Origem</Paragraph>
            <Paragraph fontWeight="semibold">
              {`${capitalizar(cidade_origem_nome)} - ${cidade_origem_estado}`}
            </Paragraph>
          </Item>
          <Item>
            <Paragraph>Destino</Paragraph>
            <Paragraph fontWeight="semibold">
              {`${capitalizar(cidade_destino_nome)} - ${cidade_destino_estado}`}
            </Paragraph>
          </Item>
        </Row>
        <Row>
          <Item>
            <Paragraph>Volume</Paragraph>
            <Paragraph fontWeight="semibold">
              {formatarTonelada(volume?.toFixed(2), 0, 'ton')}
            </Paragraph>
          </Item>
          <Item>
            <Paragraph>Cadência</Paragraph>
            <Paragraph fontWeight="semibold">
              {formatarTonelada(cadencia?.toFixed(2), 0, 'ton')}
            </Paragraph>
          </Item>
          <Item>
            <Paragraph>Produto</Paragraph>
            <Paragraph fontWeight="semibold">{produto_descricao}</Paragraph>
          </Item>
        </Row>

        <ModalMaisDetalhes
          modalVisible={modalVisible}
          handleClose={() => setModalVisible(false)}
          cotacao={cotacao}
        />
      </Container>
    </ContainerDetalhes>
  );
}
